import React from "react";
import HeaderMenuItem from "../HeaderMenuItem";
import button_illust_out from "../../img/buttons/illust_out.png";
import button_illust_on from "../../img/buttons/illust_on.png";
import button_costume_out from "../../img/buttons/costume_out.png";
import button_costume_on from "../../img/buttons/costume_on.png";
import button_message_out from "../../img/buttons/message_out.png";
import button_message_on from "../../img/buttons/message_on.png";
import button_quiz_out from "../../img/buttons/quiz_out.png";
import button_quiz_on from "../../img/buttons/quiz_on.png";
import "./HeaderMenu.scoped.scss";
import { useLocation } from "react-router-dom";
import AppTempolaly from "../../AppTempolaly";

export default function HeaderMenu() {
  // インデックス以外から来た場合であろうとメニューボタンはpreloadする
  if (AppTempolaly.requestPreload) {
    const files = [
      button_illust_out,
      button_illust_on,
      button_costume_out,
      button_costume_on,
      button_message_out,
      button_message_on,
      button_quiz_out,
      button_quiz_on,
    ];
    for (const file of files) {
      const imgDefault = new Image();
      imgDefault.src = file;
    }
  }

  // インデックス以外から来た場合はトップページでのロード画面を無効化する
  const location = useLocation();
  const hidden = location.pathname === "/";
  if (location.pathname !== "/") {
    AppTempolaly.requestPreload = false;
  }
  return (
    <div
      style={{
        transition: "1s",
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
      }}
    >
      <div className="flex justify-center w-full py-2">
        <HeaderMenuItem
          path="/illustrations"
          imageSource={button_illust_out}
          imageHoverSource={button_illust_on}
          description="イラスト"
        ></HeaderMenuItem>
        <HeaderMenuItem
          path="/costumes"
          imageSource={button_costume_out}
          imageHoverSource={button_costume_on}
          description="きせかえ"
        ></HeaderMenuItem>
        <HeaderMenuItem
          path="/messages"
          imageSource={button_message_out}
          imageHoverSource={button_message_on}
          description="メッセージ"
        ></HeaderMenuItem>
        <HeaderMenuItem
          path="/quizzes"
          imageSource={button_quiz_out}
          imageHoverSource={button_quiz_on}
          description="クイズ"
        ></HeaderMenuItem>
      </div>
      <div className="divider">
        <hr />
      </div>
    </div>
  );
}
